import { Pipe, PipeTransform } from '@angular/core';
import { AddressModel } from '../../models';
import { ActiveCompartmentsModel } from '../../../store/state/monitoring/allocation-view';

@Pipe({
    name: 'transformCompartmentToAddress',
    standalone: false
})
export class UliTransformCompartmentPipe implements PipeTransform {
  transform(compartments: ActiveCompartmentsModel[]): AddressModel[] {
    return compartments?.map((item: ActiveCompartmentsModel) => item.compartmentAddresses[0]);
  }
}
